import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

function initBarDesignsSlider(root = document) {
    const sliders = root.querySelectorAll('.product-swiper');
    console.log(sliders);
    sliders.forEach((el) => {
        // Sprawdzenie czy Swiper jest już zainicjalizowany
        if (el.swiper) return;
        console.log(el);

        const prevEl = el.querySelector('.block-bar-designs__nav--prev');
        const nextEl = el.querySelector('.block-bar-designs__nav--next');

        // Przechowaj instancję na elemencie
        el.swiper = new Swiper(el, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 1.5,
                    spaceBetween: 24
                },
                1024: {
                    slidesPerView: 3.8,
                    spaceBetween: 28
                },
                1280: {
                    slidesPerView: 4.2,
                    spaceBetween: 28
                },
                1440: {
                    slidesPerView: 4.5,
                    spaceBetween: 28
                }
            },
            loop: false,
            speed: 600,
            navigation: {
                prevEl,
                nextEl
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => initBarDesignsSlider());
